import React from 'react'
import { Link } from 'react-router-dom'
const Register = () => {
  return (
    <div>
      <p>You can register with us <Link to='/signup'>here</Link></p>
    </div>
  )
}

export default Register
